/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui';
import { getPageData } from '../../../../reducers/pdp/selectors';
import FeatureFlags from '../../../../../util/featureFlags';
import OtherThingsToReview from './OtherThingsToReview';
import './TipsModals.less';

export function TipFrontWithoutLinks() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>Invitation Wording Tips</h3>{' '}
          <div className="section">
            <p className="desc">
              Although you might be nervous about how to word your wedding invitations, we’re here
              to help. Here’s a breakdown of what information you should include in each section.
            </p>
          </div>
          <div className="section">
            <p className="head">The Host Line:</p>
            <p className="desc">
              Located at the top, the name(s) of the event hosts appear here (typically whomever is
              paying for the wedding). This could be one set of parents, both sets of parents, the
              couple and their parents together, or just the couple.
            </p>
          </div>
          <div className="section">
            <p className="head">The Couple’s Names:</p>
            <p className="desc">
              For heterosexual couples, the bride’s name traditionally comes before the groom’s. For
              same-sex couples, the wording of the host line may dictate which name comes first: if
              one set of parents are hosting, their child’s name should come first but if you are
              hosting it yourselves, it’s a toss up.
            </p>
          </div>
          <div className="section">
            <p className="head">Information:</p>
            <p className="desc">
              The date of the wedding, where the wedding ceremony and reception are taking place,
              and the event’s start time. Include the address of the venue. You can also include
              information on guest attire.
            </p>
          </div>
          <div className="section">
            <p className="head">Party Line:</p>
            <p className="desc">
              Wrap up with a line at the end that lets guest know what’s scheduled to follow the
              ceremony (a reception, dinner and dancing, etc.).
            </p>
            <p className="desc">
              If you still have questions,{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/invitation-wording/how-to-word-wedding-invitations/"
                target="_blank"
              >
                our expert advice
              </Link>{' '}
              on invitation wording dos and don’ts will set you straight. Want to see invitation
              wording examples? Head on over to{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/invitation-wording/how-to-word-wedding-invitations"
                target="_blank"
              >
                this article
              </Link>{' '}
              for inspiration.
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export function TipFrontWithLinksBase({ pageData }) {
  const themeKey = pageData && pageData.websiteTheme && pageData.websiteTheme.key;
  const websiteRoute = themeKey ? `/design/${themeKey}` : '';

  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>Invitation Wording Tips</h3>
          <div className="section">
            <p className="desc">
              Although you might be nervous about how to word your wedding invitations, we’re here
              to help. Here’s a breakdown of what information you should include in each section.
            </p>
          </div>
          <div className="section">
            <p className="head">The Host Line:</p>
            <p className="desc">
              Located at the top, the name(s) of the event hosts appear here (typically whomever is
              paying for the wedding). This could be one set of parents, both sets of parents, the
              couple and their parents together, or just the couple.
            </p>
          </div>
          <div className="section">
            <p className="head">The Couple’s Names:</p>
            <p className="desc">
              For heterosexual couples, the bride’s name traditionally comes before the groom’s. For
              same-sex couples, the wording of the host line may dictate which name comes first: if
              one set of parents are hosting, their child’s name should come first but if you are
              hosting it yourselves, it’s a toss up.
            </p>
          </div>
          <div className="section">
            <p className="head">Information:</p>
            <p className="desc">
              The date of the wedding, where the wedding ceremony and reception are taking place,
              and the event’s start time. Include the address of the venue. You can also include
              information on guest attire, your wedding website, and your registry. Start your
              website with a{' '}
              <Link inline target="_blank" href={`/wedding/manage/website${websiteRoute}`}>
                matching design
              </Link>{' '}
              or start a{' '}
              <Link inline target="_blank" href="/wedding-registry/how-it-works">
                registry
              </Link>{' '}
              with Zola!
            </p>
          </div>
          <div className="section">
            <p className="head">Party Line:</p>
            <p className="desc">
              Wrap up with a line at the end that lets guest know what’s scheduled to follow the
              ceremony (a reception, dinner and dancing, etc.).
            </p>
            <p className="desc">
              If you still have questions,{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/invitation-wording/how-to-word-wedding-invitations/"
                target="_blank"
              >
                our expert advice
              </Link>{' '}
              on invitation wording dos and don’ts will set you straight. Want to see invitation
              wording examples? Head on over to{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/invitation-wording/how-to-word-wedding-invitations"
                target="_blank"
              >
                this article
              </Link>{' '}
              for inspiration.
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export const mapStateToProps = state => ({
  pageData: getPageData(state),
});

export const TipFrontWithLinks = connect(mapStateToProps)(TipFrontWithLinksBase);

const TipFrontSwitch = () => {
  if (FeatureFlags.get('invitesTipModalsWithLinks')) {
    return <TipFrontWithLinks />;
  }

  return <TipFrontWithoutLinks />;
};

export default TipFrontSwitch;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/TipsModals/TipFront.jsx